import React, { useEffect, useState } from 'react';
import { collection, deleteDoc, doc, getDocs, query, where } from 'firebase/firestore';
import { useFirebase } from 'containers/FirebaseContext';
import Slider from 'react-slick';
import { get } from 'lodash';
import { Tooltip } from '@mui/material';
import Loading from 'components/Loading';
import * as Sentry from '@sentry/react';
import PreviewLoteria from './PreviewLoteria';
import { DeleteModal } from 'components/Dialog';
import { useCurrentUser } from 'store/users/selectors';
import { CheckCircleRounded } from '@mui/icons-material';
import GameLoteriaLoaader from './GameLoteriaLoaader';

const SampleNextArrow = (props) => {
  const { className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <i className="fa" aria-hidden="true"></i>
    </div>
  );
};

const SamplePrevArrow = (props) => {
  const { className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <i className="fa" aria-hidden="true"></i>
    </div>
  );
};

const settings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 5,
  slidesToScroll: 1,
  swipeToSlide: true,
  className: 'center',
  prevArrow: <SamplePrevArrow />,
  nextArrow: <SampleNextArrow />,
  responsive: [
    {
      breakpoint: 1092,
      settings: {
        slidesToShow: 4,
      },
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};
const DraftLoteriaList = ({ bookId, pageId, newMaskId = '', onEditGame = () => {}, gameEditLoader }) => {
  const { firestore } = useFirebase();
  const currentUser = useCurrentUser();
  const [drafts, setDrafts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteItem, setDeleteItem] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [getDeleteItem, setGetDeleteItem] = useState();

  useEffect(() => {
    const fetchDrafts = async () => {
      setLoading(true);
      setError(null);
      try {
        const collectionRef = collection(firestore, import.meta.env.VITE_APP_STAGE?.trim() === 'prod' ? 'draft_activity_prod' : 'draft_activity');
        const q = query(collectionRef, where('chapter', '==', bookId), where('page', '==', String(pageId)));
        const querySnapshot = await getDocs(q);
        const draftList = [];
        querySnapshot.forEach((doc) => {
          const data = doc.data();
          if (Object.prototype.hasOwnProperty.call(data, 'bingo_type')) {
            draftList.push({ id: doc.id, ...doc.data() });
          }
        });
        setDrafts(draftList);
      } catch (err) {
        setError('Failed to load drafts.');
        Sentry.captureException(err);
      } finally {
        setLoading(false);
      }
    };

    fetchDrafts();
  }, [firestore, bookId, pageId]);

  const handleDelete = async () => {
    if (!deleteItem) return;
    setDeleteLoading(true);
    try {
      const docRef = doc(firestore, import.meta.env.VITE_APP_STAGE?.trim() === 'prod' ? 'draft_activity_prod' : 'draft_activity', deleteItem.id);
      await deleteDoc(docRef);

      setDrafts(drafts.filter((d) => d.id !== deleteItem.id));
      setDeleteModal(false);
      setDeleteItem(null);
    } catch (error) {
      console.error('error', error);
      Sentry.captureException(error);
    } finally {
      setDeleteLoading(false);
    }
  };
  
  if (loading) {
    return <GameLoteriaLoaader />;
  }

  if (drafts.length == 0) {
    return (
      <div class="skeleton-wrapper">
        <div class="skeleton-card" style={{ textAlign: 'center' }}>
          No Draft available!
        </div>
      </div>
    );
  }
  
  return (
    <>
      <Slider {...settings}>
        {drafts &&
          drafts?.map((item, index) => {
            return (
              <div className="myUnitsGm" key={item.id} style={{ overflow: 'hidden' }}>
                <div className="draftImage-game frameStyle">
                  <PreviewLoteria
                    grid={item?.bingo_data}
                    bingoSize={item?.configurations?.bingo_size}
                    selectedType={item?.bingo_type}
                  />
                </div>
                <div className="myUnitsTxt">
                  <div className="myUnitsInfo">
                    {item?.criteria &&
                    item.criteria.length > (window.innerWidth < 480 ? 40 : 20) ? (
                      <Tooltip title={item.criteria} placement="top">
                        <label className="text-dark">
                          {item?.criteria.slice(0, window.innerWidth < 480 ? 40 : 20) + '...'}
                        </label>
                      </Tooltip>
                    ) : (
                      <label className="text-dark">{item?.criteria || 'Untitled'}</label>
                    )}
                    {newMaskId !== '' && <span>Pg. {newMaskId || '--'}</span>}
                    <span>
                      Lotería Size:{' '}
                      {item?.configurations?.bingo_size
                        ? `${item.configurations.bingo_size} X ${item.configurations.bingo_size}`
                        : '--'}
                    </span>
                  </div>
                  <div className="myUnitsBtm">
                    <p>
                      <CheckCircleRounded /> My Creation
                    </p>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                    className="px-4"
                  >
                    <div
                      onClick={() => {
                        onEditGame(item);
                      }}
                    >
                      <p
                        className="text-dark"
                        style={{
                          fontSize: 16,
                          fontWeight: '600',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          flexDirection: 'row',
                        }}
                      >
                        Edit{gameEditLoader === item.id ? <Loading size={15} /> : null}
                      </p>
                    </div>
                    <div
                      onClick={() => {
                        setDeleteItem(item);
                        setDeleteModal(true);
                      }}
                    >
                      <p
                        className="text-dark"
                        style={{ fontSize: 16, fontWeight: '600', cursor: 'pointer' }}
                      >
                        Delete{' '}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
      </Slider>
      <DeleteModal
        message={`Do you really want to delete this Lotería, "${get(deleteItem, 'criteria', 'Untitled')}"?`}
        deleteToggle={deleteModal}
        setDeleteToggle={setDeleteModal}
        loading={deleteLoading}
        onDelete={handleDelete}
      />
    </>
  );
};

export default DraftLoteriaList;
